import styled from 'styled-components';
import Column from './column';

const DateColumn = styled(Column)`
  padding: 8px;
  flex-basis: 100%;
  border-left: 3px solid var(--grey300);
`;
export default DateColumn;
